export const baseFields = {
    date: {
        startDate: {
            label: "Consumption start date",
            errorMsg: "",
            type: "start_date_ads",
            identifier: "startDate",
            config: {},
            default: null,
            required: true,
            tempStartDate: "",
            hasError: false,
        },
        endDate: {
            label: "Consumption end date",
            errorMsg: "",
            type: "end_date_ads",
            identifier: "endDate",
            config: {},
            default: null,
            required: true,
            tempEndDate: "",
            hasError: false,
        },
        showDateModal: false,
    },
    providers: {
        label: "Channels",
        type: "provider-picker-programs",
        identifier: "providerKeys",
        title: "Channels",
        sites: [],
        channels: [],
        default: [],
        showChannelModal: false,
    },
    filmCode: {
        label: "Film codes",
        type: "filmcodepicker",
        identifier: "filmCode",
        buyingAgencies: [],
        advertisers: [],
        products: [],
        required: true,
        showFilmCodeModal: false,
    },
    buyingAgencies: {
        label: "Agency",
        type: "dropdown",
        identifier: "buyingAgencies",
        default: { label: "" },
        selectlistitems: [],
    },
    advertisers: {
        label: "Advertiser",
        type: "dropdown",
        identifier: "advertisers",
        default: { label: "" },
        selectlistitems: [],
    },
    products: {
        label: "Product",
        type: "dropdown",
        identifier: "products",
        default: { label: "" },
        selectlistitems: [],
    },
    productAdvertiserAgency: {
        showProductAdvertiserAgencyModal: false,
    },
    target_group: {
        label: "Target group",
        identifier: "target_group",
        type: "target_group_ads",
        config: {},
        showTargetGroupModal: false
    },
    spot_types: {
        label: "Film type här",
        type: "dropdown-checkboxes-spottypes",
        identifier: "spot_types",
        config: {
          options: [
            {
                text:"Trailer",
                value:"T"
            },
            {
                text:"Sponsorship",
                value:"B"
            },
            {
                text:"Commercial",
                value:"S"
            }
          ],
        },
        default: [],
        showSpotTypesModal: false
    },
    productClass: {
      label: "Product class",
      identifier: "productClasses",
      type: "productClasses",
      config: {},
      showProductClassModal: false
    }
}
export const additionalFields = {}
